import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { delay, map } from "rxjs/operators";
import { WebServiceResponse } from "../interfaces/helpTarget";
import { LogClass, Logger } from "../logger";

export abstract class AbstractAdminService {
  abstract syncCirculationsToSharePoint(): Observable<number>;
}

@LogClass()
@Injectable({
  providedIn: "root"
})
export class ProdAdminService implements AbstractAdminService {
  private logger: Logger;

  constructor(private http: HttpClient) {
    this.logger.debug("ctor");
  }

  syncCirculationsToSharePoint(): Observable<number> {
    const url = "/api/Admin/replicateCircs";
    return this.http
      .post<WebServiceResponse<number>>(url, null, {
        responseType: "json"
      })
      .pipe(
        this.logger.observableOperator("syncCirculationsToSharePoint"),
        map((res) => res.data)
      );
  }
}

@LogClass()
@Injectable({
  providedIn: "root"
})
export class MockAdminService implements AbstractAdminService {
  private logger: Logger;

  constructor() {
    this.logger.debug("ctor");
  }

  syncCirculationsToSharePoint(): Observable<number> {
    this.logger.warn("This mock does not Sync to SharePoint!");
    return of(0).pipe(delay(1500));
  }
}
